(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["dl-faq"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-dl-faq]').forEach(function (list) {
    list.addEventListener('toggle', function (e) {
      if (!e.target.open) return;
      list.querySelectorAll('details[open]').forEach(function (d) { if (d !== e.target) d.open = false; });
    }, true);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["dl-review-list"] && !Shopify.designMode) return;
  try {
    (function () {
    function init() {
      document.querySelectorAll('[data-dl-rl]').forEach(function (list) {
        if (list.dataset.open === '1') return;
        var n = parseInt(list.dataset.initial, 10) || 3;
        var items = [].slice.call(list.querySelectorAll('[data-dl-rl-item]'));
        var more = list.querySelector('[data-dl-rl-more]');
        items.forEach(function (it, i) { it.hidden = i >= n; });
        if (more) more.hidden = !(items.length > n);
      });
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-dl-rl-more] button'); if (!btn) return;
      e.preventDefault();
      var list = btn.closest('[data-dl-rl]'); if (!list) return;
      list.dataset.open = '1';
      list.querySelectorAll('[data-dl-rl-item]').forEach(function (it) { it.hidden = false; });
      btn.closest('[data-dl-rl-more]').hidden = true;
    });
    function start() {
      init();
      var queued = false;
      new MutationObserver(function (m) { if (queued) return; for (var k = 0; k < m.length; k++) { if (m[k].addedNodes.length) { queued = true; requestAnimationFrame(function () { queued = false; init(); }); break; } } }).observe(document.body, { childList: true, subtree: true });
      document.addEventListener('shopify:section:load', init);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["dl-review-slider"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-dl-mini]').forEach(function (w) {
    if (w.dataset.mvInit) return; w.dataset.mvInit = '1';
    var s = w.querySelector('.dl-mini__slides'), n = s.children.length, i = 0, t;
    function go(k) { i = (k + n) % n; s.style.transform = 'translateX(-' + (i * 100) + '%)'; }
    function arm() { clearInterval(t); if (w.dataset.autoplay === 'true' && n > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) t = setInterval(function () { go(i + 1); }, (+w.dataset.interval || 4) * 1000); }
    w.querySelector('.dl-mini__btn--prev').addEventListener('click', function () { go(i - 1); arm(); });
    w.querySelector('.dl-mini__btn--next').addEventListener('click', function () { go(i + 1); arm(); });
    arm();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["dl-story-media"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.dl-smedia video').forEach(function(v){ v.muted = true; v.setAttribute('muted',''); var p = v.play(); if (p && p.catch) p.catch(function(){}); });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["dl-ugc-row"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.dl-ugc').forEach(function(root){
    var track=root.querySelector('.dl-ugc__track'); var step=function(){var c=track.querySelector('.dl-ugc__card');return c?c.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap||16):300};
    var p=root.querySelector('.dl-ugc__arrow--prev'),n=root.querySelector('.dl-ugc__arrow--next'); if(p)p.addEventListener('click',function(){track.scrollBy({left:-step(),behavior:'smooth'})});
    if(n)n.addEventListener('click',function(){track.scrollBy({left:step(),behavior:'smooth'})});
    /* Jesse 29-09 (as on Mavae): autoplay muted while in view, pause out of view; tap toggles; play mark only while not playing */
    var vids=track.querySelectorAll('video');
    vids.forEach(function(v){
      v.muted=true; v.setAttribute('muted',''); v.playsInline=true;
      var card=v.closest('.dl-ugc__card');
      v.addEventListener('playing',function(){card&&card.classList.add('is-playing')});
      v.addEventListener('pause',function(){card&&card.classList.remove('is-playing')});
      v.addEventListener('click',function(){v.paused?v.play().catch(function(){}):v.pause()});
    });
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(es){es.forEach(function(e){var v=e.target; if(e.isIntersecting){var pr=v.play(); if(pr&&pr.catch)pr.catch(function(){});} else if(!v.paused){v.pause()}})},{threshold:0.25});
      vids.forEach(function(v){io.observe(v)});
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["dl-volume-offer"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-dl-sale-end]').forEach(function(el){
    var d = el.getAttribute('data-dl-sale-end'); if(!d) return;
    var end = new Date(d + 'T23:59:59'); if(!isNaN(end) && Date.now() > end.getTime()) el.style.display = 'none';
  });
  document.querySelectorAll('[data-dl-vol-end]').forEach(function(el){
    var d = el.getAttribute('data-dl-vol-end'); if(!d) return;
    var end = new Date(d + 'T23:59:59'); if(!isNaN(end) && Date.now() > end.getTime()) el.style.display = 'none';
  });
  } catch(e) { console.error(e); }
})();

})();
